import templateOnly, { type TOC } from "@ember/component/template-only";

interface S {
  Args: { style: string; color: string };
}

const ParogLogoComponent: TOC<S> = templateOnly();
export default ParogLogoComponent;
